import React from 'react'
import "../../styles/componentsStyles/Chat/ChatHeader.scss"
import Logo from "../../assets/logos/codemmit-logo.png"
import Dots from "../../assets/icons/three-dots.svg"

const ChatHeader = () => {
    return (
        <div className='chat-header'>
            <div className="chat-header__account-holder-info">
                <img src={Logo} alt="profile img" />
                <div className="chat-header__account-holder-details">
                    <h4>Codemmit</h4>
                    <p>Last Seen: 1 hour ago</p>
                </div>
            </div>
            {/* <div className="chat-header__action-btn-container"> */}
            <img src={Dots} alt="menu" />
            {/* </div> */}
        </div >
    )
}

export default ChatHeader